import {filter, includes, isEmpty} from 'lodash';
import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {Select} from 'components';
import {Option} from 'interfaces/option';
import {languageUtils} from 'utils/language';

type Props = {
    value: string;
    placeholder?: string;
    include?: string[];
    className?: string;
    disabled?: boolean;
    onChange: (value: string) => void;
}

export const TranslationLanguageSelector: React.FC<Props> = ({value, placeholder, className, include, disabled, onChange}) => {
    const {t} = useTranslation();

    // TODO: filter options for deepgram as it's not supported "he"
    const options = useMemo<Option[]>(() => {
        const result = languageUtils.getLanguageOptions(t);
        if (!isEmpty(include)) {
            return filter(result, (option) => includes(include, option.id));
        }
        return result;
    }, [include, t]);

    return (
        <Select
            noneOption
            value={value}
            valueAs='id'
            placeholder={placeholder}
            hidePlaceholder
            disabled={disabled}
            options={options}
            className={className}
            onChange={onChange}
        />
    );
};